'use client';

import { c as _c } from "react/compiler-runtime";
import { Stack, Tooltip, Typography } from '@mui/material';
import { CircleImage } from './circleImage';
import { TextLink } from './textLink';
import TemporalIcon from '../../../public/statics/images/apps/temporal.png';

/**
 * Link to a Temporal workflow execution. A null href renders the label disabled with `unavailableReason`
 * as its tooltip, for callers that only learn the workflow once an action has started it.
 */
export const TemporalWorkflowLink = t0 => {
  const $ = _c(13);
  const {
    href,
    unavailableReason
  } = t0;
  const t1 = href ? "" : unavailableReason;
  let t2;
  if ($[0] !== href) {
    t2 = !href && {
      opacity: "0.5"
    };
    $[0] = href;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = {
      gap: "8px",
      alignItems: "center",
      width: "max-content",
      ...t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CircleImage src={TemporalIcon} alt="temporal" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== href) {
    t5 = href ? <TextLink target="_blank" href={href}>View in Temporal</TextLink> : <Typography variant="body2">View in Temporal</Typography>;
    $[5] = href;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <Stack direction="row" sx={t3}>{t4}{t5}</Stack>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t6) {
    t7 = <Tooltip title={t1}>{t6}</Tooltip>;
    $[10] = t1;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};